export const SUBSCRIPTION_CARD_MIN_WIDTH = 240;
export const SUBSCRIPTION_CARD_MAX_WIDTH = 360;
export const SUBSCRIPTION_CARD_GAP = 12;
export const SUBSCRIPTION_CARD_PREVIEW_WIDTH = 120;

/**
 * 计算订阅卡片宽度：能完整展示全部商品时保持最大宽度，否则在宽度边界内固定露出下一张 120px。
 */
export function getSubscriptionCardWidth(containerWidth: number, cardCount: number) {
  if (containerWidth <= 0 || cardCount <= 0) return SUBSCRIPTION_CARD_MAX_WIDTH;

  const maxWidthVisibleCount = Math.floor(
    (containerWidth + SUBSCRIPTION_CARD_GAP)
    / (SUBSCRIPTION_CARD_MAX_WIDTH + SUBSCRIPTION_CARD_GAP),
  );
  if (cardCount <= maxWidthVisibleCount) return SUBSCRIPTION_CARD_MAX_WIDTH;

  let widestValidCardWidth = 0;
  for (let fullCardCount = 1; fullCardCount < cardCount; fullCardCount += 1) {
    const cardWidth = (
      containerWidth
      - SUBSCRIPTION_CARD_PREVIEW_WIDTH
      - fullCardCount * SUBSCRIPTION_CARD_GAP
    ) / fullCardCount;
    if (cardWidth >= SUBSCRIPTION_CARD_MIN_WIDTH && cardWidth <= SUBSCRIPTION_CARD_MAX_WIDTH) {
      widestValidCardWidth = Math.max(widestValidCardWidth, cardWidth);
    }
  }

  // 极窄容器或商品过少时无法同时满足宽度边界与 120px 露出，优先守住卡片宽度边界。
  return widestValidCardWidth
    ? Number(widestValidCardWidth.toFixed(3))
    : SUBSCRIPTION_CARD_MAX_WIDTH;
}
